var chunkMapping = {
	"157": [
		35212
	],
	"618": [
		10618
	],
	"636": [
		70421,
		50330,
		35271,
		77343,
		86435,
		75711,
		5534
	],
	"2503": [
		82503
	],
	"3070": [
		13070
	],
	"3488": [
		13488
	],
	"3872": [
		25377
	],
	"4623": [
		74623
	],
	"5197": [
		85197
	],
	"5368": [
		65368
	],
	"5550": [
		35550
	],
	"6678": [
		1697,
		39460,
		43369,
		99068
	],
	"6921": [
		66921
	],
	"6971": [
		82115
	],
	"9166": [
		29166
	]
};
var idToExternalAndNameMapping = {
	"1697": [
		"default",
		"./generic/elements/form",
		71305
	],
	"5534": [
		"default",
		"./generic/elements/menu-item",
		71305
	],
	"10618": [
		"default",
		"./generic/components/general/lightbox",
		71305
	],
	"13070": [
		"default",
		"./generic/components/general/sheet",
		71305
	],
	"13488": [
		"default",
		"./generic/components/general/modal",
		71305
	],
	"25377": [
		"default",
		"./generic/elements/chip",
		71305
	],
	"29166": [
		"default",
		"./generic/elements/divider",
		71305
	],
	"35212": [
		"default",
		"./generic/elements/badge",
		71305
	],
	"35271": [
		"default",
		"./generic/elements/icons",
		71305
	],
	"35550": [
		"default",
		"./generic/elements/progress-bar",
		71305
	],
	"39460": [
		"default",
		"./generic/components/general/brightcove-video-player",
		71305
	],
	"43369": [
		"default",
		"./generic/components/general/rich-text",
		71305
	],
	"50330": [
		"default",
		"./generic/components/general/toast",
		71305
	],
	"65368": [
		"default",
		"./generic/components/cards/card-fixture",
		71305
	],
	"66921": [
		"default",
		"./generic/elements/loading",
		71305
	],
	"70421": [
		"default",
		"./generic/helpers/google-tag-manager",
		71305
	],
	"74623": [
		"default",
		"./generic/components/navigation/breadcrumbs",
		71305
	],
	"75711": [
		"default",
		"./generic/elements/info-block",
		71305
	],
	"77343": [
		"default",
		"./generic/elements/button",
		71305
	],
	"82115": [
		"default",
		"./generic/components/general/button-group",
		71305
	],
	"82503": [
		"default",
		"./generic/components/general/carousel",
		71305
	],
	"85197": [
		"default",
		"./generic/components/general/component-simple-header",
		71305
	],
	"86435": [
		"default",
		"./generic/components/profile/avatar",
		71305
	],
	"99068": [
		"default",
		"./generic/elements/countdown",
		71305
	]
};
var idToRemoteMap = {
	"1697": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"5534": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"10618": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"13070": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"13488": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"25377": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"29166": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"35212": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"35271": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"35550": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"39460": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"43369": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"50330": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"65368": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"66921": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"70421": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"74623": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"75711": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"77343": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"82115": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"82503": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"85197": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"86435": [
		{
			"externalType": "script",
			"name": "core"
		}
	],
	"99068": [
		{
			"externalType": "script",
			"name": "core"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"1697": {
		"shareScope": "default",
		"name": "./generic/elements/form",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"5534": {
		"shareScope": "default",
		"name": "./generic/elements/menu-item",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"10618": {
		"shareScope": "default",
		"name": "./generic/components/general/lightbox",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"13070": {
		"shareScope": "default",
		"name": "./generic/components/general/sheet",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"13488": {
		"shareScope": "default",
		"name": "./generic/components/general/modal",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"25377": {
		"shareScope": "default",
		"name": "./generic/elements/chip",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"29166": {
		"shareScope": "default",
		"name": "./generic/elements/divider",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"35212": {
		"shareScope": "default",
		"name": "./generic/elements/badge",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"35271": {
		"shareScope": "default",
		"name": "./generic/elements/icons",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"35550": {
		"shareScope": "default",
		"name": "./generic/elements/progress-bar",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"39460": {
		"shareScope": "default",
		"name": "./generic/components/general/brightcove-video-player",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"43369": {
		"shareScope": "default",
		"name": "./generic/components/general/rich-text",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"50330": {
		"shareScope": "default",
		"name": "./generic/components/general/toast",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"65368": {
		"shareScope": "default",
		"name": "./generic/components/cards/card-fixture",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"66921": {
		"shareScope": "default",
		"name": "./generic/elements/loading",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"70421": {
		"shareScope": "default",
		"name": "./generic/helpers/google-tag-manager",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"74623": {
		"shareScope": "default",
		"name": "./generic/components/navigation/breadcrumbs",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"75711": {
		"shareScope": "default",
		"name": "./generic/elements/info-block",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"77343": {
		"shareScope": "default",
		"name": "./generic/elements/button",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"82115": {
		"shareScope": "default",
		"name": "./generic/components/general/button-group",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"82503": {
		"shareScope": "default",
		"name": "./generic/components/general/carousel",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"85197": {
		"shareScope": "default",
		"name": "./generic/components/general/component-simple-header",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"86435": {
		"shareScope": "default",
		"name": "./generic/components/profile/avatar",
		"externalModuleId": 71305,
		"remoteName": "core"
	},
	"99068": {
		"shareScope": "default",
		"name": "./generic/elements/countdown",
		"externalModuleId": 71305,
		"remoteName": "core"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}